import About from "@/pages/About";
import AboutUs from "@/pages/AboutUs";
import CultureLab from "@/pages/CultureLab";
import Home from "@/pages/Home";
import MagDrops from "@/pages/MagDrops";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import { useEffect } from "react";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
import CookieConsent from "./components/shared/CookieConsent";
import CookiePolicy from "./pages/legal/CookiePolicy";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import TermsConditions from "./pages/legal/TermsConditions";

// Cookie preferences interface
interface CookiePreferences {
  necessary: boolean;
  analytics: boolean;
  functional: boolean;
}

function App() {
  const handleCookiePreferencesSet = (preferences: CookiePreferences) => {
    console.log("Cookie preferences set:", preferences);

    // Set up Google Analytics if analytics cookies are accepted
    if (preferences.analytics && typeof window !== "undefined") {
      // Add your Google Analytics setup here when you get your GA4 ID
      console.log("Analytics cookies enabled - ready for GA setup");
    }

    // Set up functional cookies for enhanced features
    if (preferences.functional) {
      localStorage.setItem("functional-cookies-enabled", "true");
    } else {
      localStorage.removeItem("functional-cookies-enabled");
    }
  };

  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/culture-lab" element={<CultureLab />} />
          <Route path="/family-spaces" element={<Navigate to="/" />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="*" element={<Navigate to="/" />} />
          <Route path="/magdrops" element={<MagDrops />} />
        </Routes>

        {/* Global Cookie Consent Banner */}
        <CookieConsent onPreferencesSet={handleCookiePreferencesSet} />
      </div>
    </Router>
  );
}

export default App;
